import clsx from "clsx";
// import dayjs from "dayjs";
import { graphql } from "gatsby";
import { Button } from "gatsby-theme-material-ui";
// import { kebabCase } from "lodash";
import {
  // ArrowBack as ArrowBackIcon,
  SubdirectoryArrowLeft as SubdirectoryArrowLeftIcon
  // CalendarToday as CalendarTodayIcon
} from "mdi-material-ui";
import PropTypes from "prop-types";
import React, { ReactElement } from "react";
import Helmet from "react-helmet";

import { Container } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";

// import { HTMLContent } from "../components/Content";
import BlogArticle from "../components/BlogArticle";
import Layout from "../components/Layout";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      gridArea: "content",
      marginBottom: theme.spacing(4),
      [theme.breakpoints.down("sm")]: {
        marginTop: theme.spacing(2)
      },
      [theme.breakpoints.up("sm")]: {
        marginTop: theme.spacing(8)
      }
    },
    // content: {
    //   "& h2": {
    //     fontSize: "1rem"
    //   },
    //   "& img": {
    //     width: "100%"
    //   }
    // },
    // date: {
    //   alignItems: "center",
    //   display: "grid",
    //   gap: `${theme.spacing(1)}px`,
    //   gridAutoFlow: "column",
    //   justifyContent: "start"
    // },
    // heading: {
    //   margin: 0
    // },
    // taglist: {
    //   listStyle: "none",
    //   paddingInlineStart: 0,
    //   [theme.breakpoints.up("sm")]: {
    //     display: "grid",
    //     gap: `${theme.spacing(4)}px`,
    //     gridTemplateColumns: `repeat(3, 1fr)`
    //   },
    //   [theme.breakpoints.up("lg")]: {
    //     gridTemplateColumns: `repeat(4, 1fr)`
    //   }
    // },
    navigation: {
      marginTop: theme.spacing(8),
      textAlign: "center",
      [theme.breakpoints.up("sm")]: {
        paddingLeft: "30%"
      }
    }
  })
);

export const BlogPostTemplate = ({
  content,
  // contentComponent,
  tags,
  title,
  subheading,
  featuredimage,
  imagewidth,
  date,
  helmet
}): ReactElement => {
  const classes = useStyles();

  return (
    <Container className={clsx(classes.root)} component="main" fluid="fluid">
      {helmet || ""}
      <BlogArticle
        content={content}
        // contentComponent={HTMLContent}
        // description={description}
        tags={tags}
        title={title}
        subheading={subheading}
        featuredimage={featuredimage}
        imagewidth={imagewidth}
        date={date}
      />
      <nav className={clsx(classes.navigation)}>
        <Button
          variant="contained"
          color="default"
          className={classes.button}
          startIcon={<SubdirectoryArrowLeftIcon />}
          to={`/blog/`}
        >
          View all news and event articles
        </Button>
      </nav>
    </Container>
  );
};

BlogPostTemplate.propTypes = {
  content: PropTypes.node.isRequired,
  // contentComponent: PropTypes.func,
  description: PropTypes.string,
  title: PropTypes.string,
  subheading: PropTypes.string,
  date: PropTypes.string,
  helmet: PropTypes.object,
  tags: PropTypes.arrayOf(PropTypes.string),
  featuredimage: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  imagewidth: PropTypes.string
};

const BlogPost = ({ data, location }): ReactElement => {
  const { markdownRemark: post } = data;
  const rootUrl = "https://williamslynch.co.uk";
  return (
    <Layout pathname={location.pathname}>
      <BlogPostTemplate
        content={post.html}
        // contentComponent={HTMLContent}
        description={post.frontmatter.description}
        featuredimage={post.frontmatter.featuredimage}
        imagewidth={post.frontmatter.imagewidth}
        helmet={
          <Helmet titleTemplate="%s | Blog">
            <title>{`${post.frontmatter.title}`}</title>
            <meta
              name="description"
              content={`${post.frontmatter.description}`}
            />
            <meta name="image" content={`${rootUrl}${post.frontmatter.featuredimage?.childImageSharp.fluid.src}`} />
            <meta name="og:image" content={`${rootUrl}${post.frontmatter.featuredimage?.childImageSharp.fluid.src}`} />
            <meta name="twitter:image" content={`${rootUrl}${post.frontmatter.featuredimage?.childImageSharp.fluid.src}`} />
          </Helmet>
        }
        tags={post.frontmatter.tags}
        title={post.frontmatter.title}
        subheading={post.frontmatter.subheading}
        date={post.frontmatter.date}
      />
    </Layout>
  );
};

BlogPost.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.object
  }),
  location: PropTypes.object
};

export default BlogPost;

export const pageQuery = graphql`
  query BlogPostByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      frontmatter {
        # date(formatString: "MMMM DD, YYYY")
        date
        title
        subheading
        description
        tags
        featuredimage {
          childImageSharp {
            fluid(maxWidth: 960, quality: 64) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        imagewidth
      }
    }
  }
`;
